/* ==========================================================================
   Discommon PDP — bundle selector, live Add to Cart total, add-on cards
   Loaded by main-product (when "Use Discommon PDP layout" is on) and by
   sections/product-addon-grid.liquid. Works with the theme's product.js
   (<product-form>, <variant-selects>) and its cart drawer.
   ========================================================================== */
(function () {
  if (window.DGPDP) return;

  /* ---------- helpers ---------- */

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || '${{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function withDelimiters(number, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    var match = format.match(placeholder);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    // strip any HTML the shop's money format may contain
    var tmp = document.createElement('div');
    tmp.innerHTML = format.replace(placeholder, value);
    return tmp.textContent;
  }

  function emit(name, detail) {
    if (typeof window.dispatchCustomEvent === 'function') {
      window.dispatchCustomEvent(name, detail);
    } else {
      document.dispatchEvent(new CustomEvent(name, { detail: detail }));
    }
  }

  function cartAddUrl() {
    var root = (window.theme && theme.routes && theme.routes.root_url) || '/';
    if (root.slice(-1) !== '/') root += '/';
    return root + 'cart/add.js';
  }

  function defaultSections() {
    return ['main-cart', 'cart-drawer', 'cart-bubble'];
  }

  /**
   * Adds several lines in one request, then refreshes/opens the theme cart drawer
   * by reusing <product-form>.renderContents (same path as a normal add).
   */
  function addItems(items, opts) {
    opts = opts || {};
    var productForm = opts.productForm || document.querySelector('.thb-product-detail product-form:not([data-sticky])') || document.querySelector('product-form');
    var sections = productForm && productForm.getSectionsToRender
      ? productForm.getSectionsToRender().map(function (s) { return s.section; })
      : defaultSections();

    return fetch(cartAddUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items, sections: sections, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          var err = new Error(data.description || data.message || 'Could not add to cart');
          err.response = data;
          throw err;
        }
        if (productForm && productForm.renderContents && data.sections) {
          productForm.renderContents(data);
        } else if (!document.getElementById('Cart-Drawer')) {
          window.location.href = (window.theme && theme.routes && theme.routes.cart_url) || '/cart';
          return data;
        }
        emit('cart:item-added', { product: data.items ? data.items[0] : data });
        return data;
      });
  }

  /* ---------- <dg-bundle> ---------- */

  class DgBundle extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;

      var cfgEl = this.querySelector('[data-dg-bundle-config]');
      this.config = cfgEl ? JSON.parse(cfgEl.textContent) : { variants: [] };
      this.sectionId = this.dataset.section;
      this.form = document.getElementById('product-form-' + this.sectionId);
      this.productForm = this.form ? this.form.closest('product-form') : null;
      this.wrapper = this.closest('.thb-product-detail') || document;

      this.soloPriceEl = this.querySelector('[data-solo-price]');
      this.setPriceEl = this.querySelector('[data-set-price]');
      this.addonPanel = this.querySelector('[data-addon-panel]');
      this.addonImage = this.querySelector('[data-addon-image]');

      this.onChange = this.onChange.bind(this);
      this.onSubmit = this.onSubmit.bind(this);
      this.onVariantChange = this.onVariantChange.bind(this);
      this.update = this.update.bind(this);

      this.addEventListener('change', this.onChange);
      document.addEventListener('submit', this.onSubmit, true); // capture: runs before the theme's form handler
      document.addEventListener('product:variant-change', this.onVariantChange);
      document.addEventListener('change', this.onQtyChange = (e) => {
        if (e.target && e.target.name === 'quantity' && e.target.getAttribute('form') === 'product-form-' + this.sectionId) this.update();
      });
      document.addEventListener('input', this.onQtyChange);

      // The theme rewrites the button label on variant change / re-render; re-apply ours.
      this.observer = new MutationObserver(() => { if (!this._writing) this.updateLabels(); });
      this.buttons().forEach((btn) => {
        this.observer.observe(btn, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'class'] });
      });

      this.update();
    }

    disconnectedCallback() {
      document.removeEventListener('submit', this.onSubmit, true);
      document.removeEventListener('product:variant-change', this.onVariantChange);
      document.removeEventListener('change', this.onQtyChange);
      document.removeEventListener('input', this.onQtyChange);
      if (this.observer) this.observer.disconnect();
      this._init = false;
    }

    /* state */
    get bundleSelected() {
      var input = this.querySelector('.dg-bundle__input[value="set"]');
      return !!(input && input.checked && !input.disabled);
    }
    get addonInput() {
      return this.querySelector('.dg-bundle__variant-input:checked:not(:disabled)');
    }
    get quantity() {
      var q = document.getElementById('Quantity-' + this.sectionId);
      var n = q ? parseInt(q.value, 10) : 1;
      return isNaN(n) || n < 1 ? 1 : n;
    }
    get mainVariant() {
      var idInput = this.form && this.form.querySelector('[name="id"]');
      var id = idInput ? parseInt(idInput.value, 10) : null;
      var vs = this.config.variants || [];
      return vs.find(function (v) { return v.id === id; }) || vs[0];
    }
    buttons() {
      // compare elements, not form.id: the form's <input name="id"> shadows that property
      var form = this.form;
      return Array.from(document.querySelectorAll('.single-add-to-cart-button')).filter(function (b) {
        return form && b.form === form;
      });
    }

    /* events */
    onChange(e) {
      if (e.target.classList.contains('dg-bundle__variant-input')) {
        var img = e.target.dataset.image;
        if (img && this.addonImage) this.addonImage.src = img;
      }
      this.update();
    }

    onVariantChange(e) {
      var v = e.detail && e.detail.variant;
      if (v && e.detail.sectionId === this.sectionId) {
        var known = (this.config.variants || []).find(function (x) { return x.id === v.id; });
        if (known) { known.price = v.price; known.available = v.available; }
      }
      // product.js re-renders the label asynchronously; the observer catches that, this covers the rest
      this.update();
    }

    onSubmit(e) {
      if (e.target !== this.form || !this.bundleSelected) return;
      var addon = this.addonInput;
      if (!addon) return;

      e.preventDefault();
      e.stopImmediatePropagation();
      if (!this.form.reportValidity()) return;

      var main = this.mainVariant;
      var qty = this.quantity;
      var props = {};
      props._bundle_with = this.config.bundleWith;

      var buttons = this.buttons();
      if (buttons.some(function (b) { return b.classList.contains('loading'); })) return;
      buttons.forEach(function (b) { b.setAttribute('aria-disabled', true); b.classList.add('loading'); });
      if (this.productForm && this.productForm.handleErrorMessage) this.productForm.handleErrorMessage();

      // Include any line-item properties from the main form (custom option blocks)
      var mainProps = {};
      new FormData(this.form).forEach(function (val, key) {
        var m = key.match(/^properties\[(.+)\]$/);
        if (m && val !== '') mainProps[m[1]] = val;
      });

      var items = [
        { id: main.id, quantity: qty, properties: mainProps },
        { id: parseInt(addon.value, 10), quantity: qty, properties: props }
      ];

      addItems(items, { productForm: this.productForm })
        .catch((err) => {
          var msg = err && err.response ? err.response.description || err.response.message : err.message;
          if (this.productForm && this.productForm.handleErrorMessage) this.productForm.handleErrorMessage(msg);
          emit('product:variant-error', { source: 'dg-bundle', productVariantId: main.id, errors: msg, message: msg });
        })
        .finally(function () {
          buttons.forEach(function (b) { b.classList.remove('loading'); b.removeAttribute('aria-disabled'); });
        });
    }

    /* render */
    update() {
      var fmt = this.config.moneyFormat;
      var main = this.mainVariant;
      var addon = this.addonInput;
      var addonPrice = addon ? parseInt(addon.dataset.price, 10) : 0;
      var bundle = this.bundleSelected && !!addon;

      if (main && this.soloPriceEl) this.soloPriceEl.textContent = formatMoney(main.price, fmt);
      if (main && this.setPriceEl) this.setPriceEl.textContent = formatMoney(main.price + addonPrice, fmt);

      this.classList.toggle('is-bundle', bundle);
      if (this.addonPanel) this.addonPanel.hidden = !this.bundleSelected;
      if (this.form) {
        this.form.classList.toggle('dg-bundle-active', bundle && this.dataset.hideDynamic === 'true');
      }

      this.total = main ? (main.price + (bundle ? addonPrice : 0)) * this.quantity : null;
      this.updateLabels();
    }

    updateLabels() {
      if (this.total == null) return;
      var label = (this.config.addToCart || 'Add to cart') + ' — ' + formatMoney(this.total, this.config.moneyFormat);
      this._writing = true;
      this.buttons().forEach(function (btn) {
        var span = btn.querySelector('.single-add-to-cart-button--text');
        if (!span || btn.disabled || btn.classList.contains('sold-out')) return;
        if (span.textContent.trim() !== label) span.textContent = label;
      });
      // let the observer's queued records flush before re-enabling it
      Promise.resolve().then(() => { this._writing = false; });
    }
  }

  if (!customElements.get('dg-bundle')) customElements.define('dg-bundle', DgBundle);

  /* ---------- add-on cards ---------- */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-dg-add]');
    if (!btn || btn.disabled || btn.classList.contains('is-loading')) return;
    e.preventDefault();
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    addItems([{ id: parseInt(btn.dataset.dgAdd, 10), quantity: 1 }])
      .catch(function (err) {
        var msg = err && err.response ? err.response.description : err.message;
        window.alert(msg);
      })
      .finally(function () {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
      });
  });

  /* ---------- smooth scroll for the rating link ---------- */

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.dg-pdp a.star-rating-container[href^="#"]');
    if (!a) return;
    var target = document.querySelector(a.getAttribute('href'));
    if (!target) return;
    e.preventDefault();
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  });

  window.DGPDP = { addItems: addItems, formatMoney: formatMoney };
})();